import {
  ChangeEvent,
  KeyboardEvent,
  useCallback,
  useRef,
  useState,
} from 'react'
import {
  WhitespaceNotice,
  applyPasswordInputEvent,
  isWhitespaceKey,
} from '../../utils/password'
import { isTextInputElement } from '../../utils/dom'
import {
  PasswordVisibility,
  usePasswordVisibility,
} from './usePasswordVisibility'

export type PasswordField = PasswordVisibility & {
  value: string
  whitespaceNotice: WhitespaceNotice
  onChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  onKeyDown: (event: KeyboardEvent<HTMLElement>) => void
}

export const usePasswordField = (): PasswordField => {
  const [value, setValue] = useState<string>('')
  const [whitespaceNotice, setWhitespaceNotice] =
    useState<WhitespaceNotice>(undefined)
  const previousValueRef = useRef<string>('')
  const visibility = usePasswordVisibility()
  const onChange = useCallback(
    (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const result = applyPasswordInputEvent(event, previousValueRef.current)
      previousValueRef.current = result.value
      setValue(result.value)
      setWhitespaceNotice(result.notice)
    },
    []
  )
  const onKeyDown = useCallback((event: KeyboardEvent<HTMLElement>) => {
    // 同じ枠内にある表示切り替えボタンのSpaceを潰さないよう、入力要素に限定する
    if (!isTextInputElement(event.target)) {
      return
    }
    if (isWhitespaceKey(event.key)) {
      event.preventDefault()
      setWhitespaceNotice('notAllowed')
    }
  }, [])
  return { value, whitespaceNotice, onChange, onKeyDown, ...visibility }
}
